module.exports = __webpack_public_path__ + "img/img-2.09a4915b.webp";